<ng-container *ngIf="isReadOnly">
  <ng-container *ngTemplateOutlet="cutsheetinfo"> </ng-container>
</ng-container>

<ng-container *ngIf="!isReadOnly && !basicEdit">
  <div class="modal-class">
    <div class="modal-header">
      <h5 class="modal-title">
        JSN Details <span *ngIf="projectName"> - {{ projectName }}</span>
      </h5>
      <span class="fa fa-close" tabindex="-1" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></span>
    </div>
    <div class="modal-body">
      <ng-container *ngTemplateOutlet="cutsheetinfo"> </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isReadOnly && basicEdit">
  <div>
    <ng-container *ngTemplateOutlet="cutsheetinfo"></ng-container>
  </div>
</ng-container>

<ng-template #cutsheetinfo let-item>
  <div *ngIf="!basicEdit">
    <table *ngIf="!isReadOnly" class="tiles-container w-100 mt-8">
      <tr>
        <td width="10%">
          <div class="card-title border-light pt-1" style="border-radius: 0px">
            <span class="text-uppercase p-2">JSN</span>
          </div>
        </td>
        <td>
          <div class="ng-autocomplete">
            <ng-autocomplete tabindex="2" [debounceTime]="1000" [data]="jsnList"
              (inputChanged)="onJSNInputChange($event)" (inputCleared)="jsnList = []" [searchKeyword]="'name'"
              placeholder="Type and select" [(ngModel)]="selectedJSN" (selected)="onJsnSelected($event)"
              [itemTemplate]="itemTemplate">
            </ng-autocomplete>

            <ng-template #itemTemplate let-item>
              <a [innerHTML]="item.name"></a>
            </ng-template>


          </div>
        </td>
        <td [width]="!isFromCloudLib ? '26%' : '10%'">
          <span class="d-flex justify-content-end">
            <div>
              <div [ngClass]="{
                  disabled: !cutSheetForm.valid
                }" class="button button-action-icon align-items-center" (click)="onSubmit()">
                <span class="text-uppercase p-2">SAVE JSN</span>
              </div>
            </div>
            <div *ngIf="!isFromCloudLib">
              <div *ngIf="
                  [
                    'mspiga@cfg.com',
                    'poojad@advic.com',
                    'ssompotan@concoursefederal.com',
                    'mharrison@concoursefederal.com',
                    'austin@imbibe.info'
                  ].includes(userName)
                " [ngClass]="{
                  disabled:
                    !selectedJSN || !selectedJSN?.name || !cutSheetForm.valid
                }" class="button button-action-icon align-items-center ml-2" (click)="onSubmit(clibProjectId)">
                <span class="text-uppercase p-2">Add to cloud library</span>
              </div>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span *ngIf="selectedJSN?.ismillstandard" style="font-size: 12px; color: rgb(219, 75, 75)">This is a Mil. Std
            Record</span>
        </td>
      </tr>
    </table>

    <!-- <table *ngIf="!isReadOnly && isFromMilStd" class="tiles-container w-50 mt-8">
            <tr>
                <td>
                    <div class="card-title border-light ml-2 pt-1" style="border-radius: 0px;">
                        <span class="text-uppercase p-2">Project</span>
                    </div>
                </td>
                <td>
                    <div class="ng-autocomplete">
                        <ng-autocomplete
                            [debounceTime]="1000"
                            [data]="projectList"
                            [searchKeyword]="'projectname'"
                            placeholder="Type and select"
                            (inputChanged)='onProjectInputChange($event)'
                            [(ngModel)]="selectedProject"
                            (selected)='onProjectSelected($event, true)'
                            [itemTemplate]="projectItemTemplate"
                            [notFoundTemplate]="notFoundTemplate">
                        </ng-autocomplete>
        
                        <ng-template #projectItemTemplate let-item>
                            <a [innerHTML]="item?.projectname"></a>
                        </ng-template>
                    </div>
                </td>
                <td>
                    <div class="d-flex justify-content-end">
                        <div [ngClass]="{'disabled': (!selectedJSN || !selectedJSN?.name || !cutSheetForm.valid)}"
                            class="button button-action-icon align-items-center" (click)="onSubmit()">
                            <span class="text-uppercase p-2">Add Jsn</span>
                        </div>
                    </div>
                </td>
            </tr>
        </table> -->
  </div>
  <table *ngIf="isFromMainDB" class="tiles-container mt-8">
    <tr>
      <td width="10%">
        <div class="card-title border-light pt-1" style="border-radius: 0px">
          <span class="text-uppercase p-2">Project</span>
        </div>
      </td>
      <td>
        <div class="d-flex align-items-center" *ngIf="false">{{selectedProject.projectname}}</div>
        <div class="ng-autocomplete">
          <ng-autocomplete [data]="projectList" (inputChanged)="onProjectInputChange($event)" [debounceTime]="1000"
            [searchKeyword]="'projectname'" placeholder="Type and select" [(ngModel)]="selectedProject"
            (selected)="onProjectSelected($event, true)" [itemTemplate]="projectItemTemplate">
          </ng-autocomplete>

          <ng-template #projectItemTemplate let-item>
            <a [innerHTML]="item?.projectname"></a>
          </ng-template>
        </div>
      </td>
      <td width="15%">
        <div class="d-flex justify-content-end ml-2">
          <div [ngClass]="{
              disabled:
                !selectedJSN ||
                !selectedJSN?.name ||
                !cutSheetForm.valid ||
                !selectedProject ||
                selectedProject?.projectname == 'Mill Standard 1691'||
                !hasAccess('PRV_CUTSHEET.CREATE')
            }" class="button button-action-icon align-items-center" (click)="saveJSN(true)">
            <span class="text-uppercase p-2">Add to Project</span>
          </div>
        </div>
      </td>
    </tr>
  </table>
  <div>
    <div class="tiles-container" [formGroup]="cutSheetForm">
      <div class="d-flex" *ngIf="isJsnInfo">
        <div class="jsn-container">
          <div class="d-flex justify-content-between w-100">
            <div class="jsn-code-bg" style="width: 90%">
              <p class="label"> JSN - OTHER </p>
              <div class="d-flex">
                <div *ngIf="isReadOnly" class="jsn-value f-size-40" style="width: 75%">
                  {{ cutSheetForm.get("name")?.value || "N/A" }}
                </div>
                <div *ngIf="isReadOnly" class="jsn-value f-size-40" style="width: 15%">
                  {{
                  cutSheetForm.get("jsnother")?.value
                  ? cutSheetForm.get("jsnother")?.value
                  : ""
                  }}
                </div>
              </div>
              <div *ngIf="!isReadOnly">
                <div class="d-flex w-100 flex-gap-1" style="gap:7px">
                  <input class="form-control otherInputFiled f-size-40 flex-grow-1" formControlName="name" type="text"
                    placeholder="Name" />
                  <input class="form-control otherInputFiled f-size-40 w-50" formControlName="jsnother" type="text"
                    placeholder="Other" />
                </div>
              </div>
            </div>
            <div class="cat-code" style="width: 150px">
              <p class="label"> CAT CODE </p>
              <!--milstddod <p class="label">{{isFromMilStd ? 'VA' : ''}} CAT CODE </p> -->
              <!-- <br /> -->
              <div *ngIf="isReadOnly" class="cat-code-value f-size-40">
                {{
                cutSheetForm.get("acquisitioncode").get("name").value || "N/A"
                }}
              </div>
              <div *ngIf="!isReadOnly" formGroupName="acquisitioncode">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('acquisitioncode')"
                    [initialValue]="initialValue.acquisitioncode" [pendingValue]="pendingApprovals.acquisitioncode">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="styled-select" style="width: 100px">
                    <select formControlName="id" style="height: 62px; font-size: 20px"
                      [ngClass]="cutSheetForm.get('acquisitioncode')?.dirty && !!pendingApprovals.acquisitioncode && !sameValues(cutSheetForm.get('acquisitioncode')?.value,initialValue.acquisitioncode) ? 'pending-control' : ''">
                      <option *ngFor="let code of acquisitionCodes" [value]="code.id">
                        {{ code?.catcode }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!--milstddod <div *ngIf="isFromMilStd" class="cat-code cat-code-dod" style="width: 150px">
              <p class="label">DOD CAT CODE </p>
              
              <div *ngIf="isReadOnly" class="cat-code-value- f-size-40">
                {{
                cutSheetForm.get("dodcatcode").get("name").value || "N/A"
                }}
              </div>
              <div *ngIf="!isReadOnly" formGroupName="dodcatcode">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('dodcatcode')"
                    [initialValue]="initialValue.dodcatcode" [pendingValue]="pendingApprovals.dodcatcode">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="styled-select" style="width: 100px">
                    <select formControlName="id" style="height: 62px; font-size: 20px"
                      [ngClass]="cutSheetForm.get('dodcatcode')?.dirty && !!pendingApprovals.dodcatcode && !sameValues(cutSheetForm.get('dodcatcode')?.value,initialValue.dodcatcode) ? 'pending-control' : ''">
                      <option *ngFor="let code of dodcatcodes" [value]="code.id">
                        {{ code?.catcode }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="mtr">
            <span *ngIf="isReadOnly">MTR</span>
            <div class="pl-1" *ngIf="isReadOnly">
              <span *ngIf="cutSheetForm.get('mtr').value; else noData">{{
                cutSheetForm.get("mtr").value
                }}</span>
            </div>
            <div *ngIf="!isReadOnly" class="row m-0">
              <div class="input-wrapper w-100">
                <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('mtr')"
                  [initialValue]="initialValue.mtr" [pendingValue]="pendingApprovals.mtr">

                  <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                    <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                  </svg>


                </div>
                <input class="cc-form-control" formControlName="mtr" type="text" placeholder="MTR"
                  [ngClass]="cutSheetForm.get('mtr')?.dirty && !!pendingApprovals.mtr ? 'pending-control' : ''" />
              </div>
            </div>
          </div>
          <div *ngIf="!cutsheetId" class="milstdglb jsn-code-bg">
            <div class="d-flex align-items-center justify-content-between">
              <p class="label"> Use Milstd GLB?</p>
              <div class="toggle">
                <span class="mr-1">YES</span>
                <label class="switch m-0">
                  <input type="checkbox" formControlName="copymilstdglb" [checked]="showglbcopy ? true : false"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </div>
            </div>
          </div>
          <div class="table-container">
            <table class="dimensions-table" style="max-height: 173px">
              <tr>
                <th>
                  <p class="label"> DEPTH</p>
                </th>
                <td>
                  <ng-container *ngIf="isReadOnly">
                    <span [ngClass]="
                        cutSheetForm.value.depth ? 'text-lowercase' : ''
                      ">{{
                      cutSheetForm.get("depth").value
                      ? cutSheetForm.get("depth").value + " in"
                      : "N/A"
                      }}</span>
                  </ng-container>
                  <div *ngIf="!isReadOnly">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('depth')"
                        [initialValue]="initialValue.depth" [pendingValue]="pendingApprovals.depth">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input min="0" class="cc-form-control" formControlName="depth" type="number" min="0"
                        placeholder="depth" (change)="autoCalculation($event, 'depth-inch')"
                        [ngClass]="cutSheetForm.get('depth')?.dirty && !!pendingApprovals.depth ? 'pending-control' : ''" />
                    </div>
                  </div>
                </td>
                <td>
                  <ng-container *ngIf="isReadOnly">
                    <span [ngClass]="
                        cutSheetForm.value.mmdepth ? 'text-lowercase' : ''
                      ">{{
                      cutSheetForm.get("mmdepth").value
                      ? cutSheetForm.get("mmdepth").value + " mm"
                      : "N/A"
                      }}</span>
                  </ng-container>
                  <div *ngIf="!isReadOnly">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('mmdepth')"
                        [initialValue]="initialValue.mmdepth" [pendingValue]="pendingApprovals.mmdepth">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input min="0" class="cc-form-control" formControlName="mmdepth" type="number" min="0"
                        placeholder="Depth in mm" (change)="autoCalculation($event, 'depth-MM')"
                        [ngClass]="cutSheetForm.get('mmdepth')?.dirty && !!pendingApprovals.mmdepth ? 'pending-control' : ''" />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <p class="label"> WIDTH </p>
                </th>
                <td>
                  <ng-container *ngIf="isReadOnly">
                    <span [ngClass]="
                        cutSheetForm.value.width ? 'text-lowercase' : ''
                        ">{{
                      cutSheetForm.get("width").value
                      ? cutSheetForm.get("width").value + " in"
                      : "N/A"
                      }}</span>
                  </ng-container>
                  <div *ngIf="!isReadOnly">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('width')"
                        [initialValue]="initialValue.width" [pendingValue]="pendingApprovals.width">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input min="0" class="cc-form-control" formControlName="width" type="number" min="0"
                        placeholder="width" (change)="autoCalculation($event, 'width-inch')"
                        [ngClass]="cutSheetForm.get('width')?.dirty && !!pendingApprovals.width ? 'pending-control' : ''" />
                    </div>
                  </div>
                </td>
                <td>
                  <ng-container *ngIf="isReadOnly">
                    <span [ngClass]="
                        cutSheetForm.value.mmdepthwidth ? 'text-lowercase' : ''
                      ">{{
                      cutSheetForm.get("mmdepthwidth").value
                      ? cutSheetForm.get("mmdepthwidth").value + " mm"
                      : "N/A"
                      }}</span>
                  </ng-container>
                  <div *ngIf="!isReadOnly">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('mmdepthwidth')"
                        [initialValue]="initialValue.mmdepthwidth" [pendingValue]="pendingApprovals.mmdepthwidth">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input min="0" class="cc-form-control" formControlName="mmdepthwidth" type="number" min="0"
                        placeholder="Width in mm" (change)="autoCalculation($event, 'width-MM')"
                        [ngClass]="cutSheetForm.get('mmdepthwidth')?.dirty && !!pendingApprovals.mmdepthwidth ? 'pending-control' : ''" />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <p class="label"> HEIGHT </p>
                </th>
                <td>
                  <ng-container *ngIf="isReadOnly">
                    <span [ngClass]="
                        cutSheetForm.value.height ? 'text-lowercase' : ''
                      ">{{
                      cutSheetForm.get("height").value
                      ? cutSheetForm.get("height").value + " in"
                      : "N/A"
                      }}</span>
                  </ng-container>
                  <div *ngIf="!isReadOnly">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('height')"
                        [initialValue]="initialValue.height" [pendingValue]="pendingApprovals.height">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input min="0" class="cc-form-control" formControlName="height" type="number" min="0"
                        placeholder="height" (change)="autoCalculation($event, 'height-inch')"
                        [ngClass]="cutSheetForm.get('height')?.dirty && !!pendingApprovals.height ? 'pending-control' : ''" />
                    </div>
                  </div>
                </td>
                <td>
                  <ng-container *ngIf="isReadOnly">
                    <span [ngClass]="
                        cutSheetForm.value.mmdepthheight ? 'text-lowercase' : ''
                      ">{{
                      cutSheetForm.get("mmdepthheight").value
                      ? cutSheetForm.get("mmdepthheight").value + " mm"
                      : "N/A"
                      }}</span>
                  </ng-container>
                  <div *ngIf="!isReadOnly">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('mmdepthheight')"
                        [initialValue]="initialValue.mmdepthheight" [pendingValue]="pendingApprovals.mmdepthheight">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input min="0" class="cc-form-control" formControlName="mmdepthheight" type="number" min="0"
                        placeholder="Height in mm" (change)="autoCalculation($event, 'height-MM')"
                        [ngClass]="cutSheetForm.get('mmdepthheight')?.dirty && !!pendingApprovals.mmdepthheight ? 'pending-control' : ''" />
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="salient-container">
          <div class="w-100" style="height: 100%; background-color: white">
            <div class="salient-characteristics">
              <p class="label text-center"> SALIENT CHARACTERISTICS </p>
            </div>
            <div *ngIf="isReadOnly" style="overflow-y: auto; max-height: 270px" class="p-2">
              <span *ngIf="cutSheetForm.get('comment').value; else noData">{{
                cutSheetForm.get("comment").value
                }}</span>
            </div>
            <div *ngIf="!isReadOnly" class="row m-0">
              <div class="input-wrapper w-100">
                <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('comment')"
                  [initialValue]="initialValue.comment" [pendingValue]="pendingApprovals.comment">

                  <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                    <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                  </svg>
                </div>
                <textarea style="height: 362px" class="form-control p-1 otherInputFiled" rows="17"
                  formControlName="comment" type="text" placeholder="Enter Salient Characteristics"
                  [ngClass]="cutSheetForm.get('comment')?.dirty && !!pendingApprovals.comment ? 'pending-control' : ''"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="product-image-container">
          <div class="salient-characteristics d-flex justify-content-between">
            <p class="label text-center flex-grow-1"> CUTSHEET IMAGES </p>
            <div class="icon d-flex align-items-center" style="cursor: pointer; margin-right: 8px;"
              (click)="refreshImages()">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.9381 13C19.979 12.6724 20 12.3387 20 12C20 7.58172 16.4183 4 12 4C9.49942 4 7.26681 5.14727 5.7998 6.94416M4.06189 11C4.02104 11.3276 4 11.6613 4 12C4 16.4183 7.58172 20 12 20C14.3894 20 16.5341 18.9525 18 17.2916M15 17H18V17.2916M5.7998 4V6.94416M5.7998 6.94416V6.99993L8.7998 7M18 20V17.2916"
                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="icon d-flex align-items-center" style="cursor: pointer;" (click)="openCutsheetGallery()">
              <svg fill="white" width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 2H7.979C6.88 2 6 2.88 6 3.98V12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10H8V4h8v8zM4 10H2v6c0 1.1.9 2 2 2h6v-2H4v-6z" />
              </svg>
            </div>
          </div>
          <concourse-cutsheet-gallery #cutsheetGallery [jsnId]="cutsheetId" [projectId]="projectId"
            [readOnly]="isReadOnly"></concourse-cutsheet-gallery>
          <div class="image-manager-button" *ngIf="!isReadOnly && cutsheetId" (click)="manageImages()"
            ngbTooltip="Manage Images">
            <svg width="26" height="26" viewBox="0 0 8 7" fill="white" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_201_20801)">
                <path
                  d="M6.3791 4.88414H2.49171V0.996748H6.3791V4.88414ZM6.3791 0.441406H2.49171C2.34442 0.441406 2.20317 0.499915 2.09902 0.604062C1.99488 0.708209 1.93637 0.849462 1.93637 0.996748V4.88414C1.93637 5.03142 1.99488 5.17268 2.09902 5.27682C2.20317 5.38097 2.34442 5.43948 2.49171 5.43948H6.3791C6.52638 5.43948 6.66764 5.38097 6.77178 5.27682C6.87593 5.17268 6.93444 5.03142 6.93444 4.88414V0.996748C6.93444 0.849462 6.87593 0.708209 6.77178 0.604062C6.66764 0.499915 6.52638 0.441406 6.3791 0.441406ZM1.38102 1.55209H0.825684V5.99482C0.825684 6.14211 0.884193 6.28336 0.988339 6.3875C1.09249 6.49165 1.23374 6.55016 1.38102 6.55016H5.82376V5.99482H1.38102V1.55209ZM4.97964 3.02097L4.21604 4.00392L3.67181 3.34862L2.90821 4.3288H5.96259L4.97964 3.02097Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_201_20801">
                  <rect width="6.6641" height="6.6641" fill="black" transform="translate(0.547852 0.164062)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div *ngIf="false" class="image-gallery-container">
            <!-- Main Gallery Section -->
            <div class="main-gallery">
              <ngx-gallery class="default-mode" [ngClass]="{ 'edit-mode': !isReadOnly }" [options]="galleryOptions"
                [images]="galleryImages" class="ngx-gallery">
              </ngx-gallery>
              <ng-template #noImage>
                <img class="no-image" src="assets/images/sample_img.png" width="100%" />
                <span *ngIf="!isReadOnly" (click)="triggerClick()" class="box">
                  <span class="fa fa-plus"></span>
                </span>
              </ng-template>
            </div>

            <!-- Thumbnails + Upload Section -->
            <div class="thumbnail-section">
              <div class="img-overlap">
                <div *ngFor="let img of galleryImages; let i = index" class="thumbnail-item">
                  <div class="thumbnail-container">
                    <img [src]="img.small" alt="Thumbnail Image" />
                    <button *ngIf="!isReadOnly" class="delete-button" (click)="deleteImage(i)">
                      <span class="fa fa-close delete-icon"></span>
                      <!-- Close Icon -->
                    </button>
                  </div>
                </div>
              </div>

              <!-- Upload Button -->
              <div class="upload-item" (click)="triggerClick()" *ngIf="!isReadOnly">
                <input class="d-none" #file type="file" accept="image/*" multiple (change)="onSelectFile($event)" />
                <div class="upload-box">
                  <span class="fa fa-plus"></span>
                </div>
                <!-- <div class="thumbnail-title">IMAGE TITLE</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-container mt-2 mb-4" *ngIf="isJsnInfo">
        <table class="dimensions-table">
          <tr>
            <th>
              <p class="label"> QUANTITY </p>
            </th>
            <td>{{ cutSheetForm.get("quantity").value || "00" }}</td>
            <th>
              <p class="label"> UNIT COST </p>
            </th>
            <td>
              <div *ngIf="isReadOnly">
                <span>${{
                  cutSheetForm.get("unitcost").value
                  | number : "1.2-2" || "00"
                  }}</span>
              </div>
              <div *ngIf="!isReadOnly">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('unitcost')"
                    [initialValue]="initialValue.unitcost" [pendingValue]="pendingApprovals.unitcost">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <input min="0" class="cc-form-control" formControlName="unitcost" type="number" min="0"
                    placeholder="cost"
                    [ngClass]="cutSheetForm.get('unitcost')?.dirty && !!pendingApprovals.cost ? 'pending-control' : ''" />
                </div>
              </div>
            </td>
            <th>
              <p class="label">TOTAL COST </p>
            </th>
            <td>
              <span>${{
                cutSheetForm.get("totalcost").value | number : "1.2-2" || "00"
                }}</span>
              <!-- <div *ngIf="isReadOnly">
              </div> -->
              <!-- <div *ngIf="!isReadOnly">
                <input
                  min="0"
                  class="form-control"
                  formControlName="totalcost"
                  type="number"
                  min="0"
                  placeholder="cost"
                  style="height: 30px"
                />
              </div> -->
            </td>
          </tr>
        </table>
      </div>

      <div class="w-100" [ngClass]="isManufactureInfo ? 'mb-5' : 'mb-1'">
        <div class="d-flex justify-content-between header-container-bg">
          <div>
            <p class="label">MANUFACTURER INFO </p>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('manufacture-info')" *ngIf="isManufactureInfo" class="pointer-cursor">
              <path d="M12 16L6 10H18L12 16Z"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('manufacture-info')" *ngIf="!isManufactureInfo" class="pointer-cursor">
              <path d="M16 12L10 18V6L16 12Z"></path>
            </svg>
          </div>
        </div>
        <div class="table-container mt-2" *ngIf="isManufactureInfo">
          <table class="manufacture-table">
            <tr style="height: 0px !important">
              <th style="width: 150px"></th>
              <th style="width: 230px"></th>
              <th style="width: 120px"></th>
              <th></th>
              <th style="width: 150px"></th>
              <th></th>
            </tr>
            <tr>
              <th>
                <p class="label"> NOMENCLATURE</p>
              </th>
              <td colspan="3">
                <div class="pl-1" *ngIf="isReadOnly">
                  <span *ngIf="cutSheetForm.get('nomenclature').value; else noData">{{
                    cutSheetForm.get("nomenclature").value }}</span>
                </div>
                <div *ngIf="!isReadOnly" class="row m-0">
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('nomenclature')"
                      [initialValue]="initialValue.nomenclature" [pendingValue]="pendingApprovals.nomenclature">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <textarea rows="1" class="cc-form-control" formControlName="nomenclature" type="text"
                      placeholder="Enter Nomenclature"
                      [ngClass]="cutSheetForm.get('nomenclature')?.dirty && !!pendingApprovals.nomenclature ? 'pending-control' : ''"></textarea>
                  </div>
                </div>
              </td>

              <th>
                <p class="label"> MODEL NAME</p>
              </th>
              <td>
                <div class="p-1" *ngIf="isReadOnly">
                  <ng-container *ngIf="
                      selectedManufacturer?.jsn != null &&
                        selectedManufacturer?.jsn !== undefined;
                      else cutsheetModelName
                    ">
                    <span class="value">{{
                      selectedManufacturer.jsn?.modelname || "N/A"
                      }}</span>
                  </ng-container>
                  <ng-template #cutsheetModelName>
                    <span *ngIf="cutSheetForm.get('modelname').value; else noData"></span>
                    {{ cutSheetForm.get("modelname").value }}
                  </ng-template>
                </div>
                <div *ngIf="!isReadOnly" class="row p-1 m-0">
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('modelname')"
                      [initialValue]="initialValue.modelname" [pendingValue]="pendingApprovals.modelname">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <input class="cc-form-control" type="text" placeholder="Model Name" formControlName="modelname"
                      [ngClass]="cutSheetForm.get('modelname')?.dirty && !!pendingApprovals.modelname ? 'pending-control' : ''" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> MANUFACTURER</p>
              </th>
              <td [ngClass]="
                  !isReadOnly
                    ? 'd-flex justify-content-between align-items-center '
                    : ''
                ">
                <div formGroupName="manufacturer" class="flex-grow-1">
                  <div *ngIf="isReadOnly">
                    <ng-container *ngIf="
                        selectedManufacturer?.name != null &&
                          selectedManufacturer?.name !== undefined;
                        else noData
                      ">
                      <span class="value">{{
                        selectedManufacturer?.name || "N/A"
                        }}</span>
                    </ng-container>
                  </div>
                  <div *ngIf="!isReadOnly" class="manufaturerAutocomplete">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('manufacturer')"
                        [initialValue]="initialValue.manufacturer" [pendingValue]="pendingApprovals.manufacturer">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <ng-autocomplete [debounceTime]="1000" class="w-100 cc-autocomplete" [data]="allManufacturerList"
                        [searchKeyword]="'name'" placeholder="Type and select" formControlName="name"
                        (selected)="onManufacturerSelected($event, false)" (inputChanged)="onChangeSearch($event)"
                        (inputCleared)="onClearAutoComplete('manufacturer')" [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate" notFoundText="Not Found"
                        (focusout)="onFocusOut($event,'manufacturer')" #autocompleteManufacturer
                        [ngClass]="cutSheetForm.get('manufacturer')?.dirty && !!pendingApprovals.manufacturer ? 'pending-control' : ''">
                      </ng-autocomplete>
                    </div>


                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.name"></a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound" *ngIf="!loadingManufacturerList"></div>
                    </ng-template>
                  </div>
                </div>
                <div class="pointer-cursor" (click)="openAccountDialog('manufacturer')" *ngIf="!isReadOnly">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28"
                    fill="rgba(96,125,139,1)">
                    <path
                      d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z">
                    </path>
                  </svg>
                </div>
              </td>
              <th class="url">
                <p class="label"> URL</p>
              </th>
              <td>
                <ng-container *ngIf="isReadOnly">
                  <span>
                    <a class="url-set" target="_blank" [href]="cutSheetForm.get('manufacturerurl').value" *ngIf="
                        cutSheetForm.get('manufacturerurl').value;
                        else not_available
                      ">
                      {{ cutSheetForm.get("manufacturerurl").value }}
                    </a>
                    <ng-template #not_available> N/A </ng-template>
                  </span>
                </ng-container>
                <div *ngIf="!isReadOnly" class="row p-0 m-0">
                  <div class="col flat">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('manufacturerurl')"
                        [initialValue]="initialValue.manufacturerurl" [pendingValue]="pendingApprovals.manufacturerurl">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input class="cc-form-control" formControlName="manufacturerurl"
                        placeholder="Enter Manufacture URL"
                        [ngClass]="cutSheetForm.get('manufacturerurl')?.dirty && !!pendingApprovals.manufacturerurl ? 'pending-control' : ''" />
                    </div>
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> MODEL NUMBER </p>
              </th>
              <td>
                <div class="p-1" *ngIf="isReadOnly">
                  <ng-container *ngIf="
                      selectedManufacturer?.jsn != null &&
                        selectedManufacturer?.jsn !== undefined;
                      else cutsheetModelNumber
                    ">
                    <span class="value">{{
                      selectedManufacturer.jsn?.modelnumber || "N/A"
                      }}</span>
                  </ng-container>
                  <ng-template #cutsheetModelNumber>
                    <span *ngIf="cutSheetForm.get('modelnumber').value; else noData"></span>
                    {{ cutSheetForm.get("modelnumber").value }}
                  </ng-template>
                </div>
                <div *ngIf="!isReadOnly">
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('modelnumber')"
                      [initialValue]="initialValue.modelnumber" [pendingValue]="pendingApprovals.modelnumber">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <input class="cc-form-control" type="text" placeholder="Model Number" formControlName="modelnumber"
                      [ngClass]="cutSheetForm.get('modelnumber')?.dirty && !!pendingApprovals.modelnumber ? 'pending-control' : ''" />
                  </div>

                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> DEALER INFO </p>
              </th>
              <td formGroupName="dealer" [ngClass]="
                  !isReadOnly
                    ? 'd-flex justify-content-between align-items-center border-top-bottom-0'
                    : ''
                ">
                <div class="flex-grow-1">
                  <div *ngIf="isReadOnly">
                    <ng-container>
                      <span class="value">{{
                        selectedDealerInformation?.name || "N/A"
                        }}</span>
                    </ng-container>
                  </div>
                  <div *ngIf="!isReadOnly" class="manufaturerAutocomplete">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('dealer')"
                        [initialValue]="initialValue.dealer" [pendingValue]="pendingApprovals.dealer">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <ng-autocomplete [debounceTime]="1000" class="w-100 cc-autocomplete" [data]="allManufacturerList"
                        [searchKeyword]="'name'" placeholder="Type and select" formControlName="name"
                        (selected)="onDealerSelected($event, false)" (inputChanged)="onChangeSearchDealer($event)"
                        (inputCleared)="onClearAutoComplete('dealer')" [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate" (focusout)="onFocusOut($event,'dealer')"
                        #autocompleteDealer
                        [ngClass]="cutSheetForm.get('dealer')?.dirty && !!pendingApprovals.dealer ? 'pending-control' : ''">
                      </ng-autocomplete>

                      <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item.name"></a>
                      </ng-template>
                      <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound" *ngIf="!loadingManufacturerList"></div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="pointer-cursor" (click)="openAccountDialog('dealer')" *ngIf="!isReadOnly">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28"
                    fill="rgba(96,125,139,1)">
                    <path
                      d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z">
                    </path>
                  </svg>
                </div>
              </td>
              <td formGroupName="dealer">
                <div class="value" *ngIf="isReadOnly">
                  {{ selectedDealerInformation?.phone || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="phone" type="text" placeholder="Dealer phone" />
                  </div>
                </div>
              </td>
              <td formGroupName="dealer">
                <div class="value" *ngIf="isReadOnly">
                  {{ selectedDealerInformation?.email || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="email" type="text" placeholder="Dealer Email" />
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> MODEL URL </p>
              </th>
              <td>
                <ng-container *ngIf="isReadOnly">
                  <span>
                    <a class="url-set" target="_blank" [href]="cutSheetForm.get('modelurl').value" *ngIf="
                        cutSheetForm.get('modelurl').value;
                        else not_available
                      ">
                      {{ cutSheetForm.get("modelurl").value }}
                    </a>
                    <ng-template #not_available> N/A </ng-template>
                  </span>
                </ng-container>
                <div *ngIf="!isReadOnly" class="row p-0 m-0">
                  <div class="col flat">
                    <div class="input-wrapper w-100">
                      <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('modelurl')"
                        [initialValue]="initialValue.modelurl" [pendingValue]="pendingApprovals.modelurl">

                        <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                          <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                        </svg>
                      </div>
                      <input class="cc-form-control" formControlName="modelurl" placeholder="Enter Model URL"
                        [ngClass]="cutSheetForm.get('modelurl')?.dirty && !!pendingApprovals.modelurl ? 'pending-control' : ''" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="w-100" [ngClass]="isUtilityRequirements ? 'mb-5' : 'mb-1'">
        <div class="d-flex justify-content-between header-container-bg">
          <div>
            <p class="label"> UTILITY REQUIREMENTS </p>
          </div>

          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('utility-requirements')" *ngIf="isUtilityRequirements" class="pointer-cursor">
              <path d="M12 16L6 10H18L12 16Z"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('utility-requirements')" *ngIf="!isUtilityRequirements" class="pointer-cursor">
              <path d="M16 12L10 18V6L16 12Z"></path>
            </svg>
          </div>
        </div>
        <div class="table-container mt-2" *ngIf="isUtilityRequirements">
          <table class="utility-table">
            <!-- row1 -->
            <tr>
              <th class="border-right-red" style=" width: 145px;">
                <p class="label">PLUMBING </p>
              </th>
              <td colspan="3" *ngIf="isReadOnly">
                <span *ngIf="cutsheetDetails?.utility_1; else no_label">
                  <span *ngIf="
                      !cutsheetDetails?.utility_1?.name ||
                        cutsheetDetails?.utility_1?.name == '·';
                      else utility_1_details
                    ">NO</span>
                  <ng-template #utility_1_details>
                    {{ cutsheetDetails?.utility_1?.name
                    }}{{
                    cutsheetDetails?.utility_1?.description
                    ? "
                    : " +
                    cutsheetDetails?.utility_1?.description
                    : ""
                    }}
                  </ng-template>
                </span>
              </td>

              <td colspan="3" *ngIf="!isReadOnly" formGroupName="utility_1">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_1')"
                    [initialValue]="initialValue.utility_1" [pendingValue]="pendingApprovals.utility_1">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="styled-select">
                    <select formControlName="id"
                      (change)="onChangeUtility(cutSheetForm.get('utility_1.id')?.value, 'utility_1')"
                      [ngClass]="cutSheetForm.get('utility_1')?.dirty && !!pendingApprovals.utility_1 && !sameValues(cutSheetForm.get('utility_1')?.value,initialValue.utility_1) ? 'pending-control' : ''">
                      <option [ngValue]="utils?.id" *ngFor="let utils of filterUtilitiesByType(1)">
                        <span *ngIf="utils.name != '·'; else none">{{ utils?.name }} {{ utils?.description ? ':' +
                          utils?.description : '' }}</span>
                        <ng-template #none>NO</ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </td>

              <th>
                <p class="label"> DRAIN SIZE </p>
              </th>
              <td *ngIf="isReadOnly" style="width: 122px;">
                {{
                getDrainSizeMetaData(cutsheetDetails?.drainsize, "name") ||
                "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly" style="width: 122px;">
                <ng-container *ngIf="
                    cutSheetForm.get('utility_1').get('id').value == '088518cf-89e3-e911-a837-000d3a3b5b14';
                    else drainSizeChange
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #drainSizeChange>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('drainsize')"
                      [initialValue]="initialValue.drainsize" [pendingValue]="pendingApprovals.drainsize">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <div class="styled-select">
                      <select name="drainsize" formControlName="drainsize"
                        (change)="onChangeUtility($event.target.value, 'drainSize')"
                        [ngClass]="cutSheetForm.get('drainsize')?.dirty && !!pendingApprovals.drainsize && !sameValues(cutSheetForm.get('drainsize')?.value,initialValue.drainsize) ? 'pending-control' : ''">
                        <option *ngFor="let dsize of drain_size" id="drain_size" [value]="dsize.id">
                          {{ dsize.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>

              <td>
                <p class="utility-label"> UTILITY LEN (FT) </p>
              </td>
              <td *ngIf="isReadOnly" style="width: 90px;">
                {{
                cutSheetForm.get('drainsize').value == 1 ||
                cutSheetForm.get('drainsize').value == -1 ||
                cutSheetForm.get('drainsize').value == 0
                ? "N/A"
                : cutSheetForm.get("utility1plumbinglength").value
                ? cutSheetForm.get("utility1plumbinglength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly" style="width: 90px;">
                <ng-container *ngIf="
                    cutSheetForm.get('drainsize').value == 1 ||
                    cutSheetForm.get('drainsize').value == -1 ||
                      cutSheetForm.get('drainsize').value == 0 ;
                    else drainSizeChange
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #drainSizeChange>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon"
                      [appPendingApprovalTooltip]="cutSheetForm.get('utility1plumbinglength')"
                      [initialValue]="initialValue.utility1plumbinglength"
                      [pendingValue]="pendingApprovals.utility1plumbinglength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <div class="styled-select" style="width: 75px">
                      <select name="utility1plumbinglength" formControlName="utility1plumbinglength"
                        [ngClass]="cutSheetForm.get('utility1plumbinglength')?.dirty && !!pendingApprovals.utility1plumbinglength && !sameValues(cutSheetForm.get('utility1plumbinglength')?.value,initialValue.utility1plumbinglength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>

              <th>
                <p class="label"> WALL BLOCKING </p>
              </th>
              <td style="width: 122px;">
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="utility_wallblocking" [checked]="utility_wallblocking"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
            </tr>
            <!-- row2 -->
            <tr>
              <th class="border-right-golden">
                <p class="label"> ELECTRICAL </p>
              </th>
              <td *ngIf="isReadOnly">
                <span *ngIf="cutsheetDetails?.utility_2; else no_label">
                  <span *ngIf="
                      !cutsheetDetails?.utility_2?.name ||
                        cutsheetDetails?.utility_2?.name == '·';
                      else utility_2_details
                    ">NO</span>
                  <ng-template #utility_2_details>
                    {{ cutsheetDetails?.utility_2?.name
                    }}{{
                    cutsheetDetails?.utility_2?.description
                    ? " : " + cutsheetDetails?.utility_2?.description
                    : ""
                    }}
                  </ng-template>
                </span>
              </td>
              <td *ngIf="!isReadOnly" formGroupName="utility_2">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_2')"
                    [initialValue]="initialValue.utility_2" [pendingValue]="pendingApprovals.utility_2">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="styled-select">
                    <select formControlName="id"
                      (change)="onChangeUtility(cutSheetForm.get('utility_2.id')?.value, 'utility_2')"
                      [ngClass]="cutSheetForm.get('utility_2')?.dirty && !!pendingApprovals.utility_2 && !sameValues(cutSheetForm.get('utility_2')?.value,initialValue.utility_2) ? 'pending-control' : ''">
                      <option [ngValue]="utils?.id" *ngFor="let utils of filterUtilitiesByType(2)">
                        <span *ngIf="utils.name != '·'; else none">{{ utils?.name }} {{ utils?.description ? ':' +
                          utils?.description : '' }}</span>
                        <ng-template #none>NO</ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </td>

              <th class="border-right-golden">
                <p class="label"> DC </p>
              </th>
              <td style="position:relative">
                <div class="input-error-icon" style="position:absolute"
                  [appPendingApprovalTooltip]="cutSheetForm.get('utility_dedicatedcircuits')"
                  [initialValue]="initialValue.utility_dedicatedcircuits"
                  [pendingValue]="pendingApprovals.utility_dedicatedcircuits">
                  <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                    <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                  </svg>
                </div>
                <div class="input-wrapper w-100">
                  <span class="mr-1">YES</span>

                  <label class="switch">
                    <input type="checkbox" formControlName="utility_dedicatedcircuits"
                      [checked]="utility_dedicatedcircuits" [attr.disabled]="isReadOnly ? true : null" (change)="
                      onChangeUtility($event, 'utility_dedicatedcircuits')"
                      [ngClass]="cutSheetForm.get('utility_dedicatedcircuits')?.dirty && !!pendingApprovals.utility_dedicatedcircuits ? 'pending-control' : ''" />
                    <span class="slider round"></span>
                  </label>
                  <span class="ml-1">N0</span>
                </div>
              </td>

              <th class="border-right-golden">
                <p class="label"> EP </p>
              </th>
              <td style="position:relative">
                <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_emergencypower')"
                  [initialValue]="initialValue.utility_emergencypower"
                  [pendingValue]="pendingApprovals.utility_emergencypower">

                  <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                    <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                  </svg>
                </div>
                <div class="input-wrapper w-100">
                  <span class="mr-1">YES</span>

                  <label class="switch">
                    <input type="checkbox" formControlName="utility_emergencypower" [checked]="utility_emergencypower"
                      [attr.disabled]="isReadOnly ? true : null"
                      (change)="onChangeUtility($event, 'utility_emergencypower')"
                      [ngClass]="cutSheetForm.get('utility_emergencypower')?.dirty && !!pendingApprovals.utility_emergencypower ? 'pending-control' : ''" />
                    <span class="slider round"></span>
                  </label>
                  <span class="ml-1">N0</span>
                </div>
              </td>

              <td>
                <p class="utility-label"> UTILITY LEN (FT) </p>
              </td>
              <td *ngIf="isReadOnly">
                {{
                !cutSheetForm.get('utility_2').get('name').value ||
                cutSheetForm.get('utility_2').get('name').value == "·"
                ? "N/A"
                : cutSheetForm.get("utility2electricallength").value
                ? cutSheetForm.get("utility2electricallength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <ng-container *ngIf="
                    !cutSheetForm.get('utility_2').get('name').value ||
                      cutSheetForm.get('utility_2').get('name').value == '·';
                    else utilitylength_2
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #utilitylength_2>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon"
                      [appPendingApprovalTooltip]="cutSheetForm.get('utility2electricallength')"
                      [initialValue]="initialValue.utility2electricallength"
                      [pendingValue]="pendingApprovals.utility2electricallength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <div class="styled-select" style="width: 75px">
                      <select name="utility2electricallength" formControlName="utility2electricallength"
                        [ngClass]="cutSheetForm.get('utility2electricallength')?.dirty && !!pendingApprovals.utility2electricallength && !sameValues(cutSheetForm.get('utility2electricallength')?.value,initialValue.utility2electricallength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>


              <th>
                <p class="label"> TRAINING </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="utility_trainingneeded" [checked]="utility_trainingneeded"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
            </tr>
            <!-- row3 -->
            <tr>

              <th>
                <p class="label"> AMPS </p>
              </th>
              <td *ngIf="isReadOnly">
                {{
                getAmpsMetaData(cutsheetDetails?.amps, "name") ||
                "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('amps')"
                    [initialValue]="initialValue.amps" [pendingValue]="pendingApprovals.amps">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>

                  <div class="styled-select">
                    <select name="amps" formControlName="amps"
                      [ngClass]="cutSheetForm.get('amps')?.dirty && !!pendingApprovals.amps && !sameValues(cutSheetForm.get('amps')?.value,initialValue.amps) ? 'pending-control' : ''">
                      <option *ngFor="let amp of amps" id="amps" [value]="amp.value">
                        {{ amp.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>

              <th>
                <p class="label"> AO's </p>
              </th>
              <td *ngIf="isReadOnly">
                {{ cutsheetDetails?.utility_additionaloutlets || "N/A" }}
              </td>
              <td *ngIf="!isReadOnly">
                <input type="number" min="0" formControlName="utility_additionaloutlets"
                  class="cc-form-control text-start-imp" />
              </td>

              <th>
                <p class="label">NEMA TYPE </p>
              </th>

              <td *ngIf="isReadOnly">
                {{
                getOutletMetaData(
                cutsheetDetails?.utility_outlettype,
                "name"
                ) || "---"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <div class="styled-select">
                  <select name="outlet_type" formControlName="utility_outlettype" id="utility_outlettype">
                    <option *ngFor="let outlet of outlet_type" [value]="outlet.value">
                      {{ outlet.name }}
                    </option>
                  </select>
                </div>
              </td>

              <td></td>
              <td></td>

              <th>
                <p class="label"> WARRANTY (YRS) </p>
              </th>
              <td>
                <ng-container *ngIf="isReadOnly">
                  <span>{{
                    cutSheetForm.get("utility_warrantyterm").value || "N/A"
                    }}</span>
                </ng-container>
                <div *ngIf="!isReadOnly">
                  <input min="0" class="cc-form-control" formControlName="utility_warrantyterm" type="number" min="0"
                    placeholder="WARRANTY (YRS)" />
                </div>
              </td>
            </tr>
            <!-- row4 -->
            <tr>
              <th class="border-right-green">
                <p class="label"> MEDICAL GAS </p>
              </th>
              <td *ngIf="isReadOnly" colspan="5">
                <span *ngIf="cutsheetDetails?.utility_3; else no_label">
                  <span *ngIf="
                      cutSheetForm.get('utility_3').get('name').value == '·';
                      else utility_3_details
                    ">NO</span>
                  <ng-template #utility_3_details>
                    {{ cutsheetDetails?.utility_3?.name
                    }}{{
                    cutsheetDetails?.utility_3?.description
                    ? " : " + cutsheetDetails?.utility_3?.description
                    : ""
                    }}
                  </ng-template>
                </span>
              </td>
              <td *ngIf="!isReadOnly" formGroupName="utility_3" colspan="5">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_3')"
                    [initialValue]="initialValue.utility_3" [pendingValue]="pendingApprovals.utility_3">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="styled-select">
                    <select formControlName="id"
                      (change)="onChangeUtility(cutSheetForm.get('utility_3.id')?.value, 'utility_3')"
                      [ngClass]="cutSheetForm.get('utility_3')?.dirty && !!pendingApprovals.utility_3 && !sameValues(cutSheetForm.get('utility_3')?.value,initialValue.utility_3) ? 'pending-control' : ''">
                      <option [ngValue]="utils?.id" *ngFor="let utils of filterUtilitiesByType(5)">
                        <span *ngIf="utils.name != '·'; else none">{{ utils?.name }} : {{ utils?.description }}</span>
                        <ng-template #none>NO</ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td style="width: 145px">
                <p class="utility-label"> UTILITY LEN (FT) </p>
              </td>
              <td *ngIf="isReadOnly">
                {{
                !cutSheetForm.get('utility_3').get('name').value ||
                cutSheetForm.get('utility_3').get('name').value == "·"
                ? "N/A"
                : cutSheetForm.get("utility3medicalgaslength").value
                ? cutSheetForm.get("utility3medicalgaslength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <ng-container *ngIf="
                    !cutSheetForm.get('utility_3').get('name').value ||
                      cutSheetForm.get('utility_3').get('name').value == '·';
                    else utilitylength_3
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #utilitylength_3>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon"
                      [appPendingApprovalTooltip]="cutSheetForm.get('utility3medicalgaslength')"
                      [initialValue]="initialValue.utility3medicalgaslength"
                      [pendingValue]="pendingApprovals.utility3medicalgaslength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <div class="styled-select" style="width: 75px">
                      <select name="utility3medicalgaslength" formControlName="utility3medicalgaslength"
                        [ngClass]="cutSheetForm.get('utility3medicalgaslength')?.dirty && !!pendingApprovals.utility3medicalgaslength && !sameValues(cutSheetForm.get('utility3medicalgaslength')?.value,initialValue.utility3medicalgaslength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>
              <th></th>
              <td></td>
            </tr>
            <!-- row5 -->
            <tr>
              <th class="border-right-purple">
                <p class="label"> MISC. GAS</p>
              </th>
              <td *ngIf="isReadOnly" colspan="5">
                <span *ngIf="cutsheetDetails?.utility_4; else no_label">
                  <span *ngIf="
                      cutSheetForm.get('utility_4').get('name').value == '·';
                      else utility_4_details
                    ">NO</span>
                  <ng-template #utility_4_details>
                    {{ cutsheetDetails?.utility_4?.name
                    }}{{
                    cutsheetDetails?.utility_4?.description
                    ? " : " + cutsheetDetails?.utility_4?.description
                    : ""
                    }}
                  </ng-template>
                </span>
              </td>
              <td *ngIf="!isReadOnly" colspan="5" formGroupName="utility_4">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_4')"
                    [initialValue]="initialValue.utility_4" [pendingValue]="pendingApprovals.utility_4">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>

                  <div class="styled-select">
                    <select formControlName="id"
                      (change)="onChangeUtility(cutSheetForm.get('utility_4.id')?.value, 'utility_4')"
                      [ngClass]="cutSheetForm.get('utility_4')?.dirty && !!pendingApprovals.utility_4 && !sameValues(cutSheetForm.get('utility_4')?.value,initialValue.utility_4) ? 'pending-control' : ''">
                      <option [ngValue]="utils?.id" *ngFor="let utils of filterUtilitiesByType(6)">
                        <span *ngIf="utils.name != '·'; else none">{{ utils?.name }} : {{ utils?.description }}</span>
                        <ng-template #none>NO</ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <p class="utility-label"> UTILITY LEN (FT) </p>
              </td>
              <td *ngIf="isReadOnly">
                {{
                !cutSheetForm.get('utility_4').get('name').value ||
                cutSheetForm.get('utility_4').get('name').value == "·"
                ? "N/A"
                : cutSheetForm.get("utility4miscgaslength").value
                ? cutSheetForm.get("utility4miscgaslength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <ng-container *ngIf="
                    !cutSheetForm.get('utility_4').get('name').value ||
                      cutSheetForm.get('utility_4').get('name').value == '·';
                    else utilitylength_4
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #utilitylength_4>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon"
                      [appPendingApprovalTooltip]="cutSheetForm.get('utility4miscgaslength')"
                      [initialValue]="initialValue.utility4miscgaslength"
                      [pendingValue]="pendingApprovals.utility4miscgaslength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <div class="styled-select" style="width: 75px">
                      <select name="utility4miscgaslength" formControlName="utility4miscgaslength"
                        [ngClass]="cutSheetForm.get('utility4miscgaslength')?.dirty && !!pendingApprovals.utility4miscgaslength && !sameValues(cutSheetForm.get('utility4miscgaslength')?.value,initialValue.utility4miscgaslength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                      <br />
                    </div>
                  </div>
                </ng-template>
              </td>
              <th></th>
              <td></td>
            </tr>
            <!-- row6 -->
            <tr>
              <th class="border-right-sky-blue">
                <p class="label"> NON MED. GAS </p>
              </th>
              <td *ngIf="isReadOnly" colspan="5">
                <span *ngIf="cutsheetDetails?.utility_5; else no_label">
                  <span *ngIf="
                      cutSheetForm.get('utility_5').get('name').value == '·';
                      else utility_5_details
                    ">NO</span>
                  <ng-template #utility_5_details>
                    {{ cutsheetDetails?.utility_5?.name
                    }}{{
                    cutsheetDetails?.utility_5?.description
                    ? " : " + cutsheetDetails?.utility_5?.description
                    : ""
                    }}
                  </ng-template>
                </span>
              </td>
              <td *ngIf="!isReadOnly" formGroupName="utility_5" colspan="5">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_5')"
                    [initialValue]="initialValue.utility_5" [pendingValue]="pendingApprovals.utility_5">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="styled-select">
                    <select formControlName="id"
                      (change)="onChangeUtility(cutSheetForm.get('utility_5.id')?.value, 'utility_5')"
                      [ngClass]="cutSheetForm.get('utility_5')?.dirty && !!pendingApprovals.utility_5 && !sameValues(cutSheetForm.get('utility_5')?.value,initialValue.utility_5) ? 'pending-control' : ''">
                      <option [ngValue]="utils?.id" *ngFor="let utils of filterUtilitiesByType(7)">
                        <span *ngIf="utils.name != '·'; else none">{{ utils?.name }} : {{ utils?.description }}</span>
                        <ng-template #none>NO</ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td style="width: 145px">
                <p class="utility-label"> UTILITY LEN (FT) </p>
              </td>
              <td *ngIf="isReadOnly" style="width: 50px">
                {{
                !cutSheetForm.get('utility_5').get('name').value ||
                cutSheetForm.get('utility_5').get('name').value == "·"
                ? "N/A"
                : cutSheetForm.get("utility5nonmedgaslength").value
                ? cutSheetForm.get("utility5nonmedgaslength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly" style="width: 85px">
                <ng-container *ngIf="
                    !cutSheetForm.get('utility_5').get('name').value ||
                      cutSheetForm.get('utility_5').get('name').value == '·';
                    else utilitylength_5
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #utilitylength_5>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon"
                      [appPendingApprovalTooltip]="cutSheetForm.get('utility5nonmedgaslength')"
                      [initialValue]="initialValue.utility5nonmedgaslength"
                      [pendingValue]="pendingApprovals.utility5nonmedgaslength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>
                    <div class="styled-select" style="width: 75px">
                      <select name="utility5nonmedgaslength" formControlName="utility5nonmedgaslength"
                        [ngClass]="cutSheetForm.get('utility5nonmedgaslength')?.dirty && !!pendingApprovals.utility5nonmedgaslength && !sameValues(cutSheetForm.get('utility5nonmedgaslength')?.value,initialValue.utility5nonmedgaslength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>
              <th></th>
              <td></td>
            </tr>
            <!-- row7 -->
            <tr>
              <th>
                <p class="label"> MISCELLANEOUS </p>
              </th>
              <td *ngIf="isReadOnly" colspan="5">
                <span *ngIf="cutsheetDetails?.utility_6; else no_label">
                  <span *ngIf="
                      cutSheetForm.get('utility_6').get('name').value == '·';
                      else utility_6_details
                    ">NO</span>
                  <ng-template #utility_6_details>
                    {{ cutsheetDetails?.utility_6?.name
                    }}{{
                    cutsheetDetails?.utility_6?.description
                    ? " : " + cutsheetDetails?.utility_6?.description
                    : ""
                    }}
                  </ng-template>
                </span>
              </td>
              <td *ngIf="!isReadOnly" formGroupName="utility_6" colspan="5">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_6')"
                    [initialValue]="initialValue.utility_6" [pendingValue]="pendingApprovals.utility_6">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>

                  <div class="styled-select" style="width: 65px">
                    <select formControlName="id"
                      (change)="onChangeUtility(cutSheetForm.get('utility_6.id')?.value, 'utility_6')"
                      [ngClass]="cutSheetForm.get('utility_6')?.dirty && !!pendingApprovals.utility_6 && !sameValues(cutSheetForm.get('utility_6')?.value,initialValue.utility_6) ? 'pending-control' : ''">
                      <option [ngValue]="utils?.id" *ngFor="let utils of filterUtilitiesByType(100000001)">
                        <span *ngIf="utils.name != '·'; else none">{{ utils?.name }} : {{ utils?.description }}</span>
                        <ng-template #none>NO</ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <p class="utility-label"> UTILITY LEN (FT) </p>
              </td>
              <td *ngIf="isReadOnly">
                {{
                !cutSheetForm.get('utility_6').get('name').value ||
                cutSheetForm.get('utility_6').get('name').value == "·"
                ? "N/A"
                : cutSheetForm.get("utility6miscellaneouslength").value
                ? cutSheetForm.get("utility6miscellaneouslength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <ng-container *ngIf="
                    !cutSheetForm.get('utility_6').get('name').value ||
                      cutSheetForm.get('utility_6').get('name').value == '·';
                    else utilitylength_6
                  ">
                  <div>N/A</div>
                </ng-container>
                <ng-template #utilitylength_6>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon"
                      [appPendingApprovalTooltip]="cutSheetForm.get('utility6miscellaneouslength')"
                      [initialValue]="initialValue.utility6miscellaneouslength"
                      [pendingValue]="pendingApprovals.utility6miscellaneouslength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>

                    <div class="styled-select" style="width: 75px">
                      <select name="utility6miscellaneouslength" formControlName="utility6miscellaneouslength"
                        [ngClass]="cutSheetForm.get('utility6miscellaneouslength')?.dirty && !!pendingApprovals.utility6miscellaneouslength && !sameValues(cutSheetForm.get('utility6miscellaneouslength')?.value,initialValue.utility6miscellaneouslength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>
              <th></th>
              <td></td>
            </tr>
            <!-- row8 -->
            <tr>
              <th rowspan="2" class="border-right-sky-blue">
                <p class="label">Data</p>
              </th>
              <th>
                <p class="label"> Data Port</p>
              </th>
              <td style="position:relative">
                <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_data')"
                  [initialValue]="initialValue.utility_data" [pendingValue]="pendingApprovals.utility_data">

                  <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                    <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                  </svg>
                </div>
                <div class="input-wrapper w-100">
                  <span class="mr-1">YES</span>
                  <label class="switch">
                    <input type="checkbox" formControlName="utility_data" [checked]="utility_data"
                      [attr.disabled]="isReadOnly ? true : null" (change)="onChangeUtility($event, 'utility_data')"
                      [ngClass]="cutSheetForm.get('utility_data')?.dirty && !!pendingApprovals.utility_data ? 'pending-control' : ''" />
                    <span class="slider round"></span>
                  </label>
                  <span class="ml-1">NO</span>
                </div>
              </td>

              <th>
                <p class="label">No. Of Drops </p>
              </th>
              <td *ngIf="isReadOnly" colspan="2">
                {{ cutsheetDetails?.utility_numberofdrops || "NO" }}
              </td>
              <td *ngIf="!isReadOnly" colspan="2">
                <div class="input-wrapper w-100">
                  <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('utility_numberofdrops')"
                    [initialValue]="initialValue.utility_numberofdrops"
                    [pendingValue]="pendingApprovals.utility_numberofdrops">

                    <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                      <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                    </svg>
                  </div>

                </div>
                <input type="number" min="0" formControlName="utility_numberofdrops"
                  class="cc-form-control text-start-imp"
                  [ngClass]="cutSheetForm.get('utility_numberofdrops')?.dirty && !!pendingApprovals.utility_numberofdrops ? 'pending-control' : ''" />
              </td>

              <td>
                <p class="utility-label">CABLE LEN (FT)</p>
              </td>
              <td *ngIf="isReadOnly">
                {{
                !cutsheetDetails?.utility_data
                ? "N/A"
                : cutSheetForm.get("datautilitylength").value
                ? cutSheetForm.get("datautilitylength").value
                : "N/A"
                }}
              </td>
              <td *ngIf="!isReadOnly">
                <ng-container *ngIf="!cutSheetForm.get('utility_data').value; else utilityDATA">
                  <div>N/A</div>
                </ng-container>
                <ng-template #utilityDATA>
                  <div class="input-wrapper w-100">
                    <div class="input-error-icon" [appPendingApprovalTooltip]="cutSheetForm.get('datautilitylength')"
                      [initialValue]="initialValue.datautilitylength"
                      [pendingValue]="pendingApprovals.datautilitylength">

                      <svg style="vertical-align:baseline" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 8.5L8.5 2" stroke="white" stroke-linecap="round" />
                        <path d="M2 13L13 2" stroke="white" stroke-linecap="round" />
                      </svg>
                    </div>

                    <div class="styled-select" style="width: 75px">
                      <select name="datautilitylength" formControlName="datautilitylength"
                        [ngClass]="cutSheetForm.get('datautilitylength')?.dirty && !!pendingApprovals.datautilitylength && !sameValues(cutSheetForm.get('datautilitylength')?.value,initialValue.datautilitylength) ? 'pending-control' : ''">
                        <option *ngFor="let ul of utilitylengths" id="utilitylength" [value]="ul.id">
                          {{ ul.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ng-template>
              </td>
              <th></th>
              <td></td>
            </tr>
            <!-- row9 -->

            <tr>
              <th>
                <p class="label">Wireless</p>
              </th>
              <td>
                <div class="input-wrapper w-100">
                  <span class="mr-1">YES</span>
                  <label class="switch">
                    <input type="checkbox" formControlName="utility_wallblocking" [checked]="utility_wallblocking"
                      [attr.disabled]="isReadOnly ? true : null"
                      (change)="onChangeUtility($event, 'utility_wallblocking')"
                      [ngClass]="cutSheetForm.get('utility_wallblocking')?.dirty && !!pendingApprovals.utility_wallblocking ? 'pending-control' : ''" />
                    <span class="slider round"></span>
                  </label>
                  <span class="ml-1">NO</span>
                </div>
              </td>
              <td colspan="7"></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="w-100" [ngClass]="isInformationDetails ? 'mb-5' : 'mb-1'">
        <div class="d-flex justify-content-between header-container-bg">
          <div>INSTALLATION DETAILS</div>

          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('information-details')" *ngIf="isInformationDetails" class="pointer-cursor">
              <path d="M12 16L6 10H18L12 16Z"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('information-details')" *ngIf="!isInformationDetails" class="pointer-cursor">
              <path d="M16 12L10 18V6L16 12Z"></path>
            </svg>
          </div>
        </div>
        <div class="table-container mt-2" *ngIf="isInformationDetails">
          <table class="information-install-table">
            <tr>
              <th>
                <p class="label"> INSTALLATION AREA </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{ selectedinstallationarea?.name || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div class="styled-select">
                    <select formControlName="installationarea">
                      <option *ngFor="let area of allInstallationArea" [value]="area?.id">
                        {{ area?.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> SHOW MODEL </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="showmodel" [checked]="showmodel"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
              <th>
                <p class="label"> MOUNTED HEIGHT </p>
              </th>
              <td>
                <ng-container *ngIf="isReadOnly">
                  <span>{{
                    cutSheetForm.get("mountedheight").value || "N/A"
                    }}</span>
                </ng-container>
                <div *ngIf="!isReadOnly">
                  <input min="0" class="cc-form-control" formControlName="mountedheight" type="number" min="0"
                    placeholder="Mounted Height" />
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> WORK SURFACES </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="worksurfaces" [checked]="worksurfaces"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
              <th>
                <p class="label"> REQUIRED MODEL </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="requiremodel" [checked]="requiremodel"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
              <th></th>
              <td></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="w-100" [ngClass]="isInstallationInfo ? 'mb-5' : 'mb-1'">
        <div class="d-flex justify-content-between header-container-bg">
          <div>
            <p class="label"> INSTALLATION INFORMATION </p>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('installation-information')" *ngIf="isInstallationInfo" class="pointer-cursor">
              <path d="M12 16L6 10H18L12 16Z"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
              (click)="showHideContent('installation-information')" *ngIf="!isInstallationInfo" class="pointer-cursor">
              <path d="M16 12L10 18V6L16 12Z"></path>
            </svg>
          </div>
        </div>
        <div class="table-container mt-2" *ngIf="isInstallationInfo">
          <table class="manufacture-table">
            <tr>
              <th>
                <p class="label"> INSTALLED BY </p>
              </th>
              <td colspan="2">
                <div *ngIf="isReadOnly">
                  {{ selectedinstalledby?.name || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div class="styled-select">
                    <select formControlName="installedby">
                      <option *ngFor="let installBy of allInstalledBy" [value]="installBy?.id">
                        {{ installBy?.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> 3RD PARTY VENDOR NAME </p>
              </th>
              <td style="width:200px">
                <div class="" [ngClass]="
                  !isReadOnly
                    ? 'd-flex justify-content-between align-items-center '
                    : ''
                ">
                  <div formGroupName="thirdpartyvendor" class=" flex-grow-1">
                    <div *ngIf="isReadOnly">
                      <ng-container *ngIf="
                        selectedThirdPartVendor?.name != null &&
                          selectedThirdPartVendor?.name !== undefined;
                        else noData
                      ">
                        <span class="value">{{
                          selectedThirdPartVendor?.name || "N/A"
                          }}</span>
                      </ng-container>
                    </div>
                    <div *ngIf="!isReadOnly" class="manufaturerAutocomplete">
                      <ng-autocomplete [debounceTime]="1000" class="w-100 cc-autocomplete" [data]="allManufacturerList"
                        [searchKeyword]="'name'" placeholder="Type and select" formControlName="name"
                        (selected)="onThirdPartVendorSelected($event, false)"
                        (inputChanged)="onChangeSearchThirdParty($event)" (inputCleared)="onClearAutoComplete('vendor')"
                        [itemTemplate]="itemTemplate" (focusout)="onFocusOut($event,'vendor')"
                        [notFoundTemplate]="notFoundTemplate" #autocompleteVendor>
                      </ng-autocomplete>

                      <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item.name"></a>
                      </ng-template>
                      <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound" *ngIf="!loadingManufacturerList"></div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="pointer-cursor" (click)="openAccountDialog('3rd party vendor')" *ngIf="!isReadOnly">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28"
                      fill="rgba(96,125,139,1)">
                      <path
                        d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z">
                      </path>
                    </svg>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> INSTALLATION DATE </p>
              </th>
              <td colspan="2">
                <div *ngIf="isReadOnly">
                  {{
                  cutSheetForm.get("installationdate")?.value
                  | date : "MM/dd/yyyy"
                  }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="installationdate" type="date"
                      placeholder="Installation Date" />
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> 3RD PARTY POC NAME </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{ cutSheetForm.get("thirdpartypocname")?.value || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="thirdpartypocname" type="text"
                      placeholder="3RD PARTY POC NAME" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> BUILDING PROTECTION REQ </p>
              </th>
              <td colspan="2">
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="buildingprotectionreq" [checked]="buildingprotectionreq"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
              <th>
                <p class="label"> 3RD PARTY POC PHONE </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{ cutSheetForm.get("thirdpartypocphone")?.value || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="thirdpartypocphone" type="text"
                      placeholder="3RD PARTY POC PHONE" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: none" class="label">
                VERIFIED EQUIPMENT FIT
                <br />
                (HALLWAYS/DOORS)
              </th>
              <td colspan="2" rowspan="2">
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="verifiedequipfit" [checked]="verifiedequipfit"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
              <th>
                <p class="label"> 3RD PARTY POC EMAIL </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{ cutSheetForm.get("thirdpartypocemail")?.value || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="thirdpartypocemail" type="text"
                      placeholder="3RD PARTY POC EMAIL" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th></th>
              <th>
                <p class="label"> 3RD PARTY FLD SURVEY REQ </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="thirdpartyfieldsurvey" [checked]="thirdpartyfieldsurvey"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> WEIGHT (LBS) </p>
              </th>
              <td colspan="2">
                <div *ngIf="isReadOnly">
                  {{ cutSheetForm.get("weightlbs")?.value || "N/A" }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="weightlbs" type="number"
                      placeholder="WEIGHT (LBS)" />
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> 3RD PARTY INSTALL COST </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  ${{
                  cutSheetForm.get("thirdpartyinstallcost")?.value
                  | number : "1.2-2" || "00"
                  }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="thirdpartyinstallcost" type="number"
                      placeholder="3RD PARTY INSTALL COST" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> SUB TRADE REQUIRED </p>
              </th>
              <td colspan="2">
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="subtradereq" [checked]="subtradereq"
                    [attr.disabled]="isReadOnly ? true : null" (change)="removeSubTrades()" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
              <th>
                <p class="label"> EQUIP COST INCL INSTALLATION </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="utility_includesinstallations"
                    [checked]="utility_includesinstallations" [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> SUB TRADES </p>
              </th>
              <td colspan="2">
                <div *ngIf="isReadOnly && cutSheetForm.get('subtradereq')?.value">
                  <ng-container *ngFor="
                      let trade of selectedsubtrades;
                      let i = index;
                      let last = last
                    ">
                    <span>{{ trade?.name }}<span *ngIf="!last">, </span></span>
                  </ng-container>
                </div>
                <div *ngIf="!isReadOnly && cutSheetForm.get('subtradereq')?.value" class="cutsheet-details">
                  <ng-select [items]="allSubtrades" bindLabel="name" bindValue="id" [multiple]="true"
                    placeholder="Select subtrades" formControlName="subtrades">
                  </ng-select>
                </div>
              </td>
              <th>
                <p class="label"> 3RD PARTY INSTALL START DATE </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{
                  cutSheetForm.get("thirdpartyinstalldate")?.value
                  | date : "MM/dd/yyyy"
                  }}
                </div>
                <div *ngIf="!isReadOnly">
                  <div>
                    <input class="cc-form-control" formControlName="thirdpartyinstalldate" type="date"
                      placeholder="3RD PARTY INSTALL START DATE" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> LOADING DOCK AVAILABLE</p>
              </th>
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <div>ORIGIN</div>
                  <div class="pr-3">
                    <span class="mr-1">YES</span>
                    <label class="switch">
                      <input type="checkbox" formControlName="loadingdockorigin" [checked]="loadingdockorigin"
                        [attr.disabled]="isReadOnly ? true : null" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-1">N0</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <div>DESTINATION</div>
                  <div class="pr-3">
                    <span class="mr-1">YES</span>

                    <label class="switch">
                      <input type="checkbox" formControlName="loadingdockdestination" [checked]="loadingdockdestination"
                        [attr.disabled]="isReadOnly ? true : null" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-1">N0</span>
                  </div>
                </div>
              </td>
              <th>
                <p class="label"> 3RD PARTY INSTALL END DATE </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{
                  cutSheetForm.get("thirdpartyinstallcompletedate")?.value
                  | date : "MM/dd/yyyy"
                  }}
                </div>
                <div *ngIf="!isReadOnly">
                  <input class="cc-form-control" formControlName="thirdpartyinstallcompletedate" type="date"
                    placeholder="Third Part Install End Date" />
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> ELEVATOR AVAILABLE </p>
              </th>
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <div>ORGIN</div>
                  <div class="pr-3">
                    <span class="mr-1">YES</span>
                    <label class="switch">
                      <input type="checkbox" formControlName="elevatororigin" [checked]="elevatororigin"
                        [attr.disabled]="isReadOnly ? true : null" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-1">N0</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <div>DESTINATION</div>
                  <div class="pr-3">
                    <span class="mr-1">YES</span>
                    <label class="switch">
                      <input type="checkbox" formControlName="destination" [checked]="destination"
                        [attr.disabled]="isReadOnly ? true : null" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-1">N0</span>
                  </div>
                </div>
              </td>

              <th>
                <p class="label"> CALIBRATION AND TESTING </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="calibrationtesting" [checked]="calibrationtesting"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
            </tr>
            <tr>
              <th>
                <p class="label"> INSTALLATION NOTE </p>
              </th>
              <td colspan="2">
                <div *ngIf="isReadOnly">
                  {{ cutSheetForm.get("installationnote")?.value }}
                </div>
                <div *ngIf="!isReadOnly">
                  <textarea rows="2" class="cc-form-control" formControlName="installationnote" type="text"
                    placeholder="Enter Installation Note"></textarea>
                </div>
              </td>
              <th>
                <p class="label"> SHOP DRAWINGS REQUIRED </p>
              </th>
              <td>
                <span class="mr-1">YES</span>

                <label class="switch">
                  <input type="checkbox" formControlName="shopdrawings" [checked]="shopdrawings"
                    [attr.disabled]="isReadOnly ? true : null" />
                  <span class="slider round"></span>
                </label>
                <span class="ml-1">N0</span>
              </td>
            </tr>
            <tr>
              <th></th>
              <td colspan="2"></td>
              <th>
                <p class="label"> SHOP DRAWINGS REQ DATE </p>
              </th>
              <td>
                <div *ngIf="isReadOnly">
                  {{
                  cutSheetForm.get("shopdrawingsreceiveddt")?.value
                  | date : "MM/dd/yyyy"
                  }}
                </div>
                <div *ngIf="!isReadOnly">
                  <input class="cc-form-control" formControlName="shopdrawingsreceiveddt" type="date"
                    placeholder="SHOP DRAWINGS REQUIRED DATE" />
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- <br> -->
    <!-- <div [formGroup]="cutSheetForm" class="custom-grid-attributes mb-2">
      <div>
        <div class="card">
          <div class="card-title pl-1">Show Model</div>
          <div class="card-body p-0" style="height: 70px">
            <span class="box-container row flat d-flex">
              <span class="col flat">
                <ng-container *ngIf="isReadOnly">
                  <span class="pl-1 bold-condensed huge text-right absolute">{{
                    ["", null].includes(cutSheetForm.get("showmodel").value)
                      ? "N/A"
                      : cutSheetForm.get("showmodel").value
                      ? "YES"
                      : "NO"
                  }}</span>
                </ng-container>
                <div *ngIf="!isReadOnly" class="row p-0 m-0">
                  <div class="col flat">
                    <select
                      [value]="cutSheetForm.get('showmodel').value"
                      formControlName="showmodel"
                    >
                      <option [value]="true">Yes</option>
                      <option [value]="false">No</option>
                    </select>
                  </div>
                </div>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-title pl-1">Model URL</div>
          <div class="card-body p-0" style="height: 70px">
            <span class="box-container row flat d-flex">
              <span class="col flat">
                <ng-container *ngIf="isReadOnly">
                  <span class="bold-condensed text-ellipsis huge pl-1 absolute">
                    <a
                      target="_blank"
                      [href]="cutSheetForm.get('modelurl').value"
                      *ngIf="
                        cutSheetForm.get('modelurl').value;
                        else not_available
                      "
                    >
                      {{ cutSheetForm.get("modelurl").value }}
                    </a>
                    <ng-template #not_available> N/A </ng-template>
                  </span>
                </ng-container>
                <div *ngIf="!isReadOnly" class="row p-0 m-0">
                  <div class="col flat">
                    <input
                      style="
                        font-size: 35px;
                        height: 70px;
                        padding: 0px;
                        padding-top: 5px;
                      "
                      class="form-control"
                      formControlName="modelurl"
                      placeholder="Enter Model URL"
                    />
                  </div>
                </div>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-title pl-1">Default Note</div>
          <div class="card-body p-0" style="height: 70px">
            <span class="box-container row flat d-flex">
              <span class="col flat">
                <ng-container *ngIf="isReadOnly">
                  <span
                    class="bold-condensed small pl-1 text-scroll absolute"
                    >{{ cutSheetForm.get("defaultnote").value || "N/A" }}</span
                  >
                </ng-container>
                <div *ngIf="!isReadOnly" class="row p-0 m-0">
                  <div class="col flat">
                    <textarea
                      style="
                        font-size: 35px;
                        height: 70px;
                        padding: 0px;
                        padding-top: 5px;
                      "
                      class="form-control"
                      formControlName="defaultnote"
                      placeholder="Enter Default Note"
                    ></textarea>
                  </div>
                </div>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- NEW TABLE START -->

    <div *ngIf="selectedJSN && selectedJSN?.name" class="table-wrapper">
      <div class="d-flex justify-content-between header-container-bg">
        <div>
          <p class="label"> QUANTITIES + LOCATIONS </p>
        </div>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
            (click)="showHideContent('quantity-location')" *ngIf="isQuantityLocation" class="pointer-cursor">
            <path d="M12 16L6 10H18L12 16Z"></path>
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(247,148,29,1)"
            (click)="showHideContent('quantity-location')" *ngIf="!isQuantityLocation" class="pointer-cursor">
            <path d="M16 12L10 18V6L16 12Z"></path>
          </svg>
        </div>
      </div>
      <div class="content-wrapper" *ngIf="isQuantityLocation">
        <div class="row flat d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div class="p-2" style="min-width: 280px; max-width: 480px;">
              <ng-select placeholder="SELECT DEPARTMENT" [multiple]="true" [items]="availableDepartments"
                [bindLabel]="'departmentname'" [closeOnSelect]="false" [(ngModel)]="selectedDepartments"
                (change)="onDeptSelectionChange()" class="custom-ng-select">
                <ng-template ng-header-tmp>
                  <label>
                    <input type="checkbox" (change)="toggleSelectAllDepts($event)" [checked]="isAllDeptsSelected()" />
                    Select All
                  </label>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <label>
                    <input type="checkbox" [checked]="selectedDepartments.includes(item)" />
                    {{ item.departmentname }}
                  </label>
                </ng-template>
              </ng-select>
            </div>
            <div class="button add-jsn-room d-flex align-items-center m-2"
              [ngClass]="{'disabled': !selectedDepartments?.length || (!selectedJSN?.id && !cutsheetId)}"
              (click)="addJsnToDepartment()">
              <span class="text-uppercase">ADD JSN TO DEPARTMENT</span>
            </div>
          </div>
          <div class="button add-jsn-room d-flex align-items-center m-2" (click)="openAddJsnToRoomDialogue()">
            <span class="text-uppercase">ADD JSN TO ROOM</span>
          </div>
        </div>
        <div class="col table-title" *ngIf="projectDetails" style="background: none; color: #33af18">
          JSN added to rooms
          <a (click)="redirectToRooms()" class="redirect-jsn" style="color: #5440ae">&nbsp; click here &nbsp;</a>
          to approve.
        </div>
        <table class="content-table w-100">
          <tbody>
            <tr>
              <th width="10%" (click)="
                  roomnumber.checked = !roomnumber.checked;
                  sortByColumn(newRoomData, 'roomnumber', !roomnumber.checked)
                ">
                <input class="d-none" type="checkbox" [checked]="false" #roomnumber />
                <span [ngClass]="{ active_sort: sortColumn == 'roomnumber' }"
                  class="d-flex flex-row align-items-center">
                  ROOM#
                  <span *ngIf="roomnumber.checked; else desc">
                    <div class="chevron north"></div>
                  </span>
                  <ng-template #desc>
                    <div class="chevron south"></div>
                  </ng-template>
                </span>
              </th>
              <th width="30%" (click)="
                  roomname.checked = !roomname.checked;
                  sortByColumn(newRoomData, 'roomname', !roomname.checked)
                ">
                <input class="d-none" type="checkbox" [checked]="false" #roomname />
                <span [ngClass]="{ active_sort: sortColumn == 'roomname' }" class="d-flex flex-row align-items-center">
                  ROOM NAME
                  <span *ngIf="roomname.checked; else desc">
                    <div class="chevron north"></div>
                  </span>
                  <ng-template #desc>
                    <div class="chevron south"></div>
                  </ng-template>
                </span>
              </th>
              <th width="50%" (click)="
                  department.checked = !department.checked;
                  sortByColumn(newRoomData, 'department', !department.checked)
                ">
                <input class="d-none" type="checkbox" [checked]="false" #department />
                <span [ngClass]="{ active_sort: sortColumn == 'department' }"
                  class="d-flex flex-row align-items-center">
                  DEPARTMENT
                  <span *ngIf="department.checked; else desc">
                    <div class="chevron north"></div>
                  </span>
                  <ng-template #desc>
                    <div class="chevron south"></div>
                  </ng-template>
                </span>
              </th>
              <th width="10%" (click)="
                  quantity.checked = !quantity.checked;
                  sortByColumn(newRoomData, 'quantity', !quantity.checked)
                ">
                <input class="d-none" type="checkbox" [checked]="false" #quantity />
                <span [ngClass]="{ active_sort: sortColumn == 'quantity' }" class="d-flex flex-row align-items-center">
                  QTY.
                  <span *ngIf="quantity.checked; else desc">
                    <div class="chevron north"></div>
                  </span>
                  <ng-template #desc>
                    <div class="chevron south"></div>
                  </ng-template>
                </span>
              </th>
            </tr>
            <ng-container *ngIf="newRoomData && newRoomData.length > 0; else noRowData">
              <tr style="font-family: 'BentonSans-Book'" *ngFor="let content of newRoomData">
                <td>
                  {{ content?.roomnumber }}
                </td>
                <td>
                  {{ content?.roomname }}
                </td>
                <td>
                  {{ content?.department }}
                </td>
                <!-- <td
                  class="text-center d-flex align-items-center justify-content-between"
                >
                  <div class="mr-auto ml-auto">{{ content?.quantity }}</div>
                  <div
                    (click)="confirmDelete(content)"
                    class="stand-right ml-auto"
                  >
                    <button
                      style="height: 35px !important; width: 35px !important"
                      class="action-text h-100 text-light border-0"
                    >
                      <span class="fa fa-trash text-light"></span>
                    </button>
                  </div>
                </td> -->
                <td class="text-center">
                  {{ content?.quantity }}
                </td>
              </tr>
            </ng-container>
            <ng-template #noRowData>
              <tr>
                <td class="text-center" colspan="4">No Data Found</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
    <!-- NEW TABLE END -->
  </div>
</ng-template>

<ng-template #noData>
  <div class="no-data m-auto text-center">N/A</div>
</ng-template>

<ng-template #no_label>
  <span>NO</span>
</ng-template>